var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.list),function(report){return [_c('ItemTitle',{key:report.key,attrs:{"title":report.name}}),_vm._l((_vm.ReportData[report.key]),function(item){return _c('StateanAlysis',{key:item.id,attrs:{"item":item}})})]}),_c('HealthReport')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }